var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H0V0Z",
    fill: "#DA291C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45583 7.69297C3.45583 5.0753 5.578 2.95312 8.19568 2.95312C9.49826 2.95312 10.6781 3.47943 11.5347 4.33026L11.5356 4.32981C11.5356 4.32981 13.1426 5.62615 13.1426 8.03982C13.1426 10.453 11.1111 13.0497 8.19568 13.0497H2.88623C2.85498 13.0497 2.84873 13.0404 2.86748 13.0216C2.95319 12.9368 3.22504 12.6676 3.56609 12.3266C4.05891 11.8342 4.26247 11.4543 4.26247 10.8611C4.26247 10.5245 4.15935 10.1781 4.0665 10.0218C4.066 10.0211 4.06606 10.0197 4.06614 10.0183C4.06619 10.0172 4.06625 10.0161 4.06606 10.0151C3.67903 9.32857 3.45583 8.53755 3.45583 7.69297ZM9.67692 10.2463C9.70103 10.2598 9.72803 10.2667 9.75543 10.2666C9.76753 10.2669 9.77962 10.2657 9.79148 10.2632C9.87999 10.2445 9.93707 10.1551 9.91899 10.0636L9.60659 8.45962L10.6894 7.33956C10.7159 7.31198 10.7324 7.27579 10.7361 7.23709C10.7451 7.14411 10.6795 7.06121 10.5896 7.05193L9.04721 6.89289L8.43222 5.45982C8.41575 5.42118 8.38591 5.39031 8.34855 5.37327C8.2659 5.33557 8.16935 5.37432 8.13291 5.45982L7.51792 6.89289L5.97718 7.05193C5.93849 7.05555 5.90231 7.0733 5.87512 7.10199C5.81188 7.16871 5.8129 7.27584 5.87741 7.34125L6.95854 8.46131L6.64778 10.0636C6.63953 10.1044 6.64614 10.1469 6.66634 10.183C6.71161 10.2639 6.81168 10.2914 6.88985 10.2446L8.28338 9.44602L9.67692 10.2463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPriority);
export default __webpack_public_path__ + "static/media/open-priority.d62143431bc5e6505625dbb2e5070c76.svg";
export { ForwardRef as ReactComponent };